import Button from "../../../shared/components/elements/Button";
import type { AuthMode } from "../types";

interface ModeSwitchProps {
    mode: AuthMode;
    onSwitch: () => void;
}

// "or" divider and the button that flips between login and register
const ModeSwitch = ({ mode, onSwitch }: ModeSwitchProps) => {
    return (
        <>
            <div className="w-full flex items-center justify-between flex-1 gap-x-3 text-lg text-gray-400 my-8">
                <span className="h-0.5 bg-gray-300 w-full" />
                <span>یا</span>
                <span className="h-0.5 bg-gray-300 w-full" />
            </div>

            <Button onClick={onSwitch}>
                <span>{mode === "login" ? "ثبت نام" : "ورود"}</span>
            </Button>
        </>
    );
};

export default ModeSwitch;